module.exports = __webpack_public_path__ + "static/media/favicon.8ab904ed.svg";